<button mat-mini-fab
        class="fab"
        [matTooltip]="'Notifications' | translate"
        [matMenuTriggerFor]="menu">
    <mat-icon color="primary">{{ notificationsProvider.unSeenNotifications.length > 0 ? 'notifications' : 'notifications_none' }}</mat-icon>
    <div *ngIf="notificationsProvider.unSeenNotifications.length > 0"
         class="counter background-color-warn">
        {{ notificationsProvider.unSeenNotifications.length }}
    </div>
</button>
<mat-menu #menu="matMenu"
          xPosition="before">
    <div class="header">
        <div class="main-title">{{ 'Notifications' | translate }}</div>
        <button *ngIf="!isMarkAllSeenLoading"
                mat-icon-button
                [matTooltip]="'Mark_all_read' | translate"
                [disabled]="notificationsProvider.notifications.length == 0"
                (click)="onMarkAllReadClicked($event)">
            <mat-icon>done_all</mat-icon>
        </button>
        <div *ngIf="isMarkAllSeenLoading"
             class="spinner">
            <mat-spinner [diameter]="24">
            </mat-spinner>
        </div>
    </div>
    <mat-divider></mat-divider>
    <div *ngIf="notificationsProvider.notifications.length == 0"
         class="info">
        {{ 'All_caught_up' | translate }}
    </div>
    <ng-container *ngIf="notificationsProvider.notifications.length > 0">
        <div *ngFor="let notification of notificationsProvider.notifications"
             mat-menu-item
             [class.notification-unseen]="!notification.read_at"
             class="notification-item"
             (click)="onNotificationClicked($event, notification)">
            <mat-icon *ngIf="notification.data?.leftIcon"
                      class="left-content">
                {{ notification.data?.leftIcon }}
            </mat-icon>
            <div class="content">
                <div class="legend">
                    {{ notification.created_at | dateClosest }}
                </div>
                <div class="title">{{ notification.data?.title ?? '' | ellipsize:25 }}</div>
                <div class="text">
                    <ng-container *ngIf="notification.data?.message">{{ (notification.data?.message || '') | ellipsize:80 }}</ng-container>
                </div>
            </div>
        </div>
    </ng-container>
</mat-menu>
